import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { getAddExpectContinuePlugin } from "@aws-sdk/middleware-expect-continue";
import { resolveFlexibleChecksumsConfig } from "@aws-sdk/middleware-flexible-checksums";
import { getHostHeaderPlugin, resolveHostHeaderConfig } from "@aws-sdk/middleware-host-header";
import { getLoggerPlugin } from "@aws-sdk/middleware-logger";
import { getRecursionDetectionPlugin } from "@aws-sdk/middleware-recursion-detection";
import { getRegionRedirectMiddlewarePlugin, getS3ExpressHttpSigningPlugin, getS3ExpressPlugin, getValidateBucketNamePlugin, resolveS3Config } from "@aws-sdk/middleware-sdk-s3";
import { getUserAgentPlugin, resolveUserAgentConfig } from "@aws-sdk/middleware-user-agent";
import { resolveRegionConfig } from "@smithy/config-resolver";
import { DefaultIdentityProviderConfig, getHttpAuthSchemeEndpointRuleSetPlugin, getHttpSigningPlugin } from "@smithy/core";
import { resolveEventStreamSerdeConfig } from "@smithy/eventstream-serde-config-resolver";
import { getContentLengthPlugin } from "@smithy/middleware-content-length";
import { resolveEndpointConfig } from "@smithy/middleware-endpoint";
import { getRetryPlugin, resolveRetryConfig } from "@smithy/middleware-retry";
import { Client as __Client } from "@smithy/smithy-client";
import { defaultS3HttpAuthSchemeParametersProvider, resolveHttpAuthSchemeConfig } from "./auth/httpAuthSchemeProvider";
import { CreateSessionCommand } from "./commands/CreateSessionCommand";
import { resolveClientEndpointParameters } from "./endpoint/EndpointParameters";
import { getRuntimeConfig as __getRuntimeConfig } from "./runtimeConfig";
import { resolveRuntimeExtensions } from "./runtimeExtensions";
export { __Client };
export var S3Client = /*#__PURE__*/function (_Client) {
  _inherits(S3Client, _Client);
  var _super = _createSuper(S3Client);
  function S3Client() {
    var _this;
    for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
      _ref[_key] = arguments[_key];
    }
    var configuration = _ref[0];
    _classCallCheck(this, S3Client);
    var _config_0 = __getRuntimeConfig(configuration || {});
    var _config_1 = resolveClientEndpointParameters(_config_0);
    var _config_2 = resolveUserAgentConfig(_config_1);
    var _config_3 = resolveFlexibleChecksumsConfig(_config_2);
    var _config_4 = resolveRetryConfig(_config_3);
    var _config_5 = resolveRegionConfig(_config_4);
    var _config_6 = resolveHostHeaderConfig(_config_5);
    var _config_7 = resolveEndpointConfig(_config_6);
    var _config_8 = resolveEventStreamSerdeConfig(_config_7);
    var _config_9 = resolveHttpAuthSchemeConfig(_config_8);
    var _config_10 = resolveS3Config(_config_9, {
      session: [function () {
        return _assertThisInitialized(_this);
      }, CreateSessionCommand]
    });
    var _config_11 = resolveRuntimeExtensions(_config_10, (configuration === null || configuration === void 0 ? void 0 : configuration.extensions) || []);
    _this = _super.call(this, _config_11);
    _this.config = _config_11;
    _this.middlewareStack.use(getUserAgentPlugin(_this.config));
    _this.middlewareStack.use(getRetryPlugin(_this.config));
    _this.middlewareStack.use(getContentLengthPlugin(_this.config));
    _this.middlewareStack.use(getHostHeaderPlugin(_this.config));
    _this.middlewareStack.use(getLoggerPlugin(_this.config));
    _this.middlewareStack.use(getRecursionDetectionPlugin(_this.config));
    _this.middlewareStack.use(getHttpAuthSchemeEndpointRuleSetPlugin(_this.config, {
      httpAuthSchemeParametersProvider: defaultS3HttpAuthSchemeParametersProvider,
      identityProviderConfigProvider: function () {
        var _identityProviderConfigProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", new DefaultIdentityProviderConfig({
                    "aws.auth#sigv4": config.credentials,
                    "aws.auth#sigv4a": config.credentials
                  }));
                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function identityProviderConfigProvider(_x) {
          return _identityProviderConfigProvider.apply(this, arguments);
        }
        return identityProviderConfigProvider;
      }()
    }));
    _this.middlewareStack.use(getHttpSigningPlugin(_this.config));
    _this.middlewareStack.use(getValidateBucketNamePlugin(_this.config));
    _this.middlewareStack.use(getAddExpectContinuePlugin(_this.config));
    _this.middlewareStack.use(getRegionRedirectMiddlewarePlugin(_this.config));
    _this.middlewareStack.use(getS3ExpressPlugin(_this.config));
    _this.middlewareStack.use(getS3ExpressHttpSigningPlugin(_this.config));
    return _this;
  }
  _createClass(S3Client, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(S3Client.prototype), "destroy", this).call(this);
    }
  }]);
  return S3Client;
}(__Client);